import type { PropsWithChildren } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import { authStore } from '../model/auth-store'
import { consumeStoredAuthReturnTo } from '../model/auth-navigation'
import { resolveSafeRedirect } from '@/shared/lib/safe-redirect'
import { AuthPendingShell } from './auth-pending-shell'

export function GuestOnlyRoute({ children }: PropsWithChildren) {
  const { initialized, mode, loginData } = useSnapshot(authStore)
  const [searchParams] = useSearchParams()

  console.log('[GuestOnlyRoute] initialized:', initialized, 'mode:', mode, 'loginData:', loginData)

  if (!initialized) {
    return <AuthPendingShell />
  }

  if (mode === 'authenticated') {
    const target = searchParams.get('redirect') ?? consumeStoredAuthReturnTo()
    console.log('[GuestOnlyRoute] User is authenticated, redirecting to:', target)
    return <Navigate replace to={resolveSafeRedirect(target)} />
  }

  console.log('[GuestOnlyRoute] Showing login page')
  return <>{children}</>
}
